import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import { Container, Dimmer, Loader, Menu } from 'semantic-ui-react';

import ActivationCodeList from './list';
import ActivationCodeFilterMenu from './filter';
import CreateResellerACLicensesModal from './createBatchResellerAcModal';

import useDebounce from '../../hooks/useDebounce';
import { AC_STATUS_FILTERS } from '../../../server/constants';
import useCanAdminLicenses from '../../hooks/useCanAdminLicenses';

const ResellerActivationCodes = ({
  canNavigateUsers = false,
  setNavigation,
  onDeactivateAc,
  onUpgradeAc,
  reseller,
  items,
  request,
  goToPage,
  pageNum,
  perPage,
  total
}) => {

  const canAdmin = useCanAdminLicenses();
  const [filters, setFilters] = useState({ term: '', showExpired: false, status: AC_STATUS_FILTERS.ALL });
  const [pagination, setPagination] = useState({ pageNum: pageNum, perPage: perPage });
  const debouncedFilter = useDebounce(filters, 300);

  const loadPage = () => {
    goToPage({
      resellerId: reseller._id,
      pageNum: pagination.pageNum,
      perPage: pagination.perPage,
      term: debouncedFilter.term,
      showExpired: debouncedFilter.showExpired,
      status: debouncedFilter.status
    });
  };

  const onGoToPage = (p, pp) => setPagination({ pageNum: p, perPage: pp });
  const onChangeFilters = (data) => setFilters(data);

  const onRefreshLicenses = () => loadPage();

  const onDeactivateLicense = (license) => {
    onDeactivateAc({ resellerId: reseller._id, licenseId: license._id });
  };

  const onUpgradeLicense = (license) => {
    onUpgradeAc({ resellerId: reseller._id, licenseId: license._id });
  };
  // Initial Page Load
  useEffect(() => {
    loadPage();
  }, [debouncedFilter, pagination]);

  return (
    <Container textAlign='left' fluid>
      <Menu size='mini'>
        {
          canAdmin ? (
            <CreateResellerACLicensesModal
              reseller={ reseller }
              onRefreshLicenses={ onRefreshLicenses }
            />
          ) : null
        }
        <Menu.Menu position='right'>
          <ActivationCodeFilterMenu onChange={ onChangeFilters } filters={ filters } />
        </Menu.Menu>
      </Menu>
      <Dimmer inverted active={ request.isLoading === true } >
        <Loader />
      </Dimmer>
      <ActivationCodeList
        canNavigateUsers={ canNavigateUsers }
        setNavigation={ setNavigation }

        canAdminLicenses={ canAdmin }
        licenses={ items || [] }
        owner={ reseller }

        onDeactivateLicense={ onDeactivateLicense }
        onUpgradeLicense={ onUpgradeLicense }

        onGoToPage={ onGoToPage }
        pageNum={ pagination.pageNum }
        perPage={ pagination.perPage }
        total={ total }
      />
    </Container>
  );
}

ResellerActivationCodes.propTypes = {

  canNavigateUsers: PropTypes.bool,
  setNavigation: PropTypes.func.isRequired,
  reseller: PropTypes.object.isRequired,
  items: PropTypes.arrayOf(PropTypes.object).isRequired,
  onDeactivateAc: PropTypes.func.isRequired,
  onUpgradeAc: PropTypes.func.isRequired,
  request: PropTypes.object.isRequired,

  goToPage: PropTypes.func.isRequired,
  pageNum: PropTypes.number.isRequired,
  perPage: PropTypes.number.isRequired,
  total: PropTypes.number.isRequired

};

export default ResellerActivationCodes;



// WEBPACK FOOTER //
// ./webAdmin/views/activationCodes/reseller.js